import { I } from '@angular/cdk/keycodes';
import { Component, OnInit } from '@angular/core';
import { FormArray, FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { NotifierService } from 'angular-notifier';
import {ReportService} from '../../service/report.service';

@Component({
  selector: 'app-club',
  templateUrl: './club.component.html',
  styleUrls: ['./club.component.scss']
})
export class ClubComponent implements OnInit {

  // public columns = ['1'];
  // public rows = ['1'];
  public isRow = false;
  public selectedCols = [];
  
  public clubForm = new FormGroup({
    rows: this.formBuilder.array([]),
    columns: this.formBuilder.array([]),
  });

  constructor(public reportService:ReportService,private formBuilder: FormBuilder,public notifier: NotifierService) { }

  ngOnInit() {
    this.resetClubForm();
    this.selectedCols = [];
    // console.log("this.reportService.jsonData is",this.reportService.jsonData);
    // console.log("this.reportService.selectedCut is",this.reportService.selectedCut);
    if (this.reportService.jsonData['sidecut'][this.reportService.selectedCut.key]['clubFormData']) {
      let formData = this.reportService.jsonData['sidecut'][this.reportService.selectedCut.key]['clubFormData'];
      for (let i = 0; i < formData.columns.length; i++) {
        this.selectedCols.push(formData.columns[i].question_name)
        this.addColumn(formData.columns[i].question_name);
        for (let j = 0; j < formData.columns[i].values.length - 1; j++) {
          this.addColumnValues(this.clubForm.get('columns')['controls'][i])
        }
      }
      for (let k = 0; k < formData.rows.length; k++) {
        this.addRow(formData.rows[k].question_name,formData.rows[k].name);
        for (let l = 0; l < formData.rows[k].values.length - 1 ; l++) {
          this.addRowValues(this.clubForm.get('rows')['controls'][k])
        }
      }
      setTimeout(()=> {
        this.clubForm.patchValue({"columns":this.reportService.jsonData['sidecut'][this.reportService.selectedCut.key]['clubFormData']['columns']})
        this.clubForm.patchValue({"rows":this.reportService.jsonData['sidecut'][this.reportService.selectedCut.key]['clubFormData']['rows']});
      }, 500)
    }else{
      // console.log("this.reportService.selectedCut['key'] ==> ",this.reportService.selectedCut['key'])
      this.addRow(this.reportService.selectedCut['key'],this.reportService.selectedCut['value']["name"]);
    }
    // console.log("this.club form is",this.clubForm.get('rows'));
    this.columnChange([Object.keys(this.reportService.selectedCut['value']['topcut'])[0]])
    
  }
  resetClubForm(){
    this.clubForm = new FormGroup({
      rows: this.formBuilder.array([]),
      columns: this.formBuilder.array([]),
    });
  }

  public createRow(question_name,name){
    return this.formBuilder.group({
      question_name : new FormControl(question_name),
      name : new FormControl(name),
      values : this.formBuilder.array([this.createRowValues()]),
    });
  }

  public addRow(question_name,name): void {
    let items = this.clubForm.get('rows') as FormArray;
    items.push(this.createRow(question_name,name));
    
  }

  removeRow(index): void {
    let items = this.clubForm.get('rows') as FormArray;
    items.removeAt(index);
  }

  public createRowValues(){
    return this.formBuilder.group({
      mergerd_values_name : new FormControl(''),
      values_merged : new FormControl([], [Validators.required]),
    });
  }

  public addRowValues(row:FormArray): void {
    let items = row.get('values') as FormArray;
    items.push(this.createRowValues());
  }

  removeRowValue(row:FormArray, index): void {
    let items = row.get('values') as FormArray;
    items.removeAt(index);
  }

  public createColumn(question_name){
    return this.formBuilder.group({
      question_name : new FormControl(question_name),
      values : this.formBuilder.array([this.createColumnValues()]),
      // columnOption: new FormControl(column['value']['topcut'])
    });
  }

  public addColumn(question_name): void {
    let items = this.clubForm.get('columns') as FormArray;
    items.push(this.createColumn(question_name));
    
  }

  removeColumn(index): void {
    let items = this.clubForm.get('columns') as FormArray;
    items.removeAt(index);
  }

  public createColumnValues(){
    // console.log("inside createColumnValues")
    return this.formBuilder.group({
      mergerd_values_name : new FormControl('',Validators.minLength(1)),
      values_merged : new FormControl([''], [Validators.required]),
    });
  }

  public addColumnValues(columns:FormArray): void {
    let items = columns.get('values') as FormArray;
    items.push(this.createColumnValues());
  }

  removeColumnValue(columns:FormArray, index): void {
    let items = columns.get('values') as FormArray;
    items.removeAt(index);
  }
 

  // add(){
  //   if(this.isRow){
  //     this.rows.push('');
  //   }else{
  //     this.columns.push('');
  //   }
  // }
  
  // remove(index){
  //   if(this.isRow){
  //     this.rows.splice(index,1);
  //   }else{
  //     this.columns.splice(index,1);
  //   }
  // }
  
  selectedTabValue(event){
    this.isRow = event.index;
  }

  onSubmit(){
    // this.reportService.clubFormData = this.clubForm;
    let clubData = JSON.parse(JSON.stringify(this.clubForm.value));
    if (clubData.rows.length ==1 && clubData.rows[0].values.length == 1) {
      if (clubData.rows[0].values[0].values_merged.length == 0) {
        clubData.rows[0].values = [];
      }
    }

    if (clubData.columns.length ==1 && clubData.columns[0].values.length == 1) {
      if (clubData.columns[0].values[0].values_merged.length == 0) {
        clubData.columns[0].values = [];
      }
    }

    let reqFormatCheck = {
      isEmptyMergerdColumnName : false,
      isEmptyMergerdRowName : false,
      message:'Something went wrong'
    }
    clubData.columns.forEach(citem => {
      if (citem.values.length) {
        for (let i = 0; i < citem.values.length; i++) {
          const cmitem = citem.values[i];
          if (cmitem.values_merged.length > 0 && cmitem.values_merged[0]['id']  && cmitem.values_merged[0]['id'].length) {
            reqFormatCheck.isEmptyMergerdColumnName = cmitem.mergerd_values_name == '' ? true : false;
          }
          if (reqFormatCheck.isEmptyMergerdColumnName) {
            reqFormatCheck.message = "Please insert name for clubbed columns";
            break;
          }
        }
      }
    });
    clubData.rows.forEach(ritem => {
      if (ritem.values.length) {
        for (let i = 0; i < ritem.values.length; i++) {
          const rmitem = ritem.values[i];
          reqFormatCheck.isEmptyMergerdRowName = (rmitem.values_merged.length > 0 && rmitem.mergerd_values_name == '') ? true : false;
          if (reqFormatCheck.isEmptyMergerdRowName) {
            reqFormatCheck.message = "Please insert name for clubbed rows";
            break;
          }
        }
      }
    });

    if ((!clubData.columns[0] || clubData.columns[0].values.length == 0 ) && (!clubData.rows[0] || clubData.rows[0].values.length == 0)) {
      this.notifier.notify('error','Please select column/row for clubbing')
    }else if (reqFormatCheck.isEmptyMergerdColumnName || reqFormatCheck.isEmptyMergerdRowName) {
      this.notifier.notify('error',reqFormatCheck.message)
    }else{
      this.reportService.mainClubReq[this.reportService.selectedCut['key']] = this.clubForm.value;
      // let body = {"data":{
      //   "data":this.reportService.selectedCut,
      //   "clubData":clubData
      // }};

      let body = {"data":{
        "clubData":clubData
      }};
      // console.log("club body is ===>",body)
      this.reportService.clubTable(body,this.clubForm.value,this.reportService.selectedCut['key']);
    }
  }

  columnChange(columns){
    let filteredColumns = [];
    // console.log("cols ",columns);
    // console.log("formcols ",this.clubForm.value.columns)
    columns.forEach(question_name => {
      // add column
      filteredColumns = this.clubForm.value.columns.filter(item =>{
        return item.question_name == question_name
      })
      if (filteredColumns.length == 0) {
        this.addColumn(question_name);
      }
    });
    this.unselectColumns(columns);
  }

  unselectColumns(columns){ 
    // remove colomn
    if (columns.length == 0) {
      this.removeColumn(0)
    }else{
      let indexes = [];
      this.clubForm.value.columns.forEach((item,index) =>{
        if (!columns.includes(item.question_name)) {
          indexes.push(JSON.stringify(index)) 
        }
      })
      setTimeout(()=>{
        indexes.forEach(our_index => {
          // console.log("index ",our_index)
          this.removeColumn(our_index)
        });
      })
    }
  
  }


  // rowChange(rows){
  //   let filteredRows = [];
  //   rows.forEach(question_name => {
  //     // add column
  //     filteredRows = this.clubForm.value.rows.filter(item =>{
  //       return item.question_name == question_name
  //     })
  //     if (filteredRows.length == 0) {
  //       this.addColumn(question_name);
  //     }
  //   });
  // }

  // unselectRow(){

  // }

}
